import { HelperConstant } from '../../helpers/HelperConstant'
import React, { InputHTMLAttributes } from 'react'
import { Col, Row } from 'reactstrap'
import logo from "../../assets/images/dofy-logo-blue.png"
import { Dictionary, groupBy, map } from "underscore";
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model';
import { IRequoteModel } from 'models/Requote.Model';


interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    data: IGetOrderSummaryModel | undefined
}


function Questionarie({ orderSummaryInfo }: any) {

    // let orderSummaryInfo: IGetOrderSummaryModel | undefined = data;
    let orderedQuestionaire: Dictionary<IRequoteModel[]> = groupBy(orderSummaryInfo?.QuestionnaireResponse?.filter(x => x.Threshold >= 0 || x.QuestionnaireTypeId === HelperConstant.questionnaireType.DeviceAge) ?? [], "QuestionnaireType");

    const GetQuestionarieIcons = (key) => {
        switch (key) {
            case 'Screening Question':
                return <i className='mdi mdi-account-question me-1 text-dofy fw-semibold font-size-16'></i>;
            case 'Screen':
                return <i className='mdi mdi-cellphone-link me-1 text-dofy fw-semibold font-size-16'></i>;
            case 'Body':
                return <i className='mdi mdi-devices me-1 text-dofy fw-semibold font-size-16'></i>;
            case 'Functional':
                return <i className='mdi mdi-cellphone-cog me-1 text-dofy fw-semibold font-size-16'></i>;
            case 'Warranty':
                return <i className='mdi mdi-shield-check me-1 text-dofy fw-semibold font-size-16'></i>;
            case 'Physical':
                return <i className='mdi mdi-monitor-clean me-1 text-dofy fw-semibold font-size-16'></i>;
            case 'Configuration':
                return <i className='mdi mdi-server me-1 text-dofy fw-semibold font-size-16'></i>;
            case 'Accessories':
                return <i className='mdi mdi-shield-check me-1 text-dofy fw-semibold font-size-16'></i>;
            default:
                return <i className='mdi mdi-battery-charging-high me-1 text-dofy fw-semibold font-size-16'></i>;
        }

    }


    return (
        <React.Fragment>
            <Row>
                {/* <Col lg={12} className='text-center'>
                    <div className="my-4">
                        <img src={logo} alt="logo" height="25" />
                    </div>
                </Col> */}
                {/* <Col xl={12}>
                    {orderSummaryInfo?.ServiceTypeId === HelperConstant.serviceTypeId.SELL ?
                        <p className='font-size-16 text-dofy fw-semibold'>Device Details</p> : <p>Parts Details</p>}
                </Col> */}
                <Col xl={12} className="mt-4">
                    {orderSummaryInfo?.ServiceTypeId === HelperConstant.serviceTypeId.SELL &&
                        <Row>
                            {orderedQuestionaire && map(orderedQuestionaire, (value: Array<any>) => {
                                const key = value[0]?.QuestionnaireType as string;
                                return (
                                    <Col key={key} xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <div className='my-1'>
                                            {GetQuestionarieIcons(key)}
                                            <span className='text-dofy fw-bold font-size-14'>{key}</span>
                                        </div>
                                        {value.map((item: any, index: any) => {
                                            return (
                                                <Row key={index} >
                                                    <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                                                        <p className='my-1'>{item?.Question}</p>
                                                    </Col>
                                                    <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                                                        <p className='text-dofy fw-semibold my-1'>{item.ResponseText ? item.ResponseText : "--"}</p>
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </Col>
                                )
                            })}

                        </Row>
                    }
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default Questionarie
